import React, { useState, useEffect } from 'react';
import { fetchDataFreshness } from '../utils/api';

function formatTimestamp(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleString();
}

function DebugPipelineFreshness({ isActive }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isActive) return;

    let cancelled = false;
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const json = await fetchDataFreshness();
        if (!cancelled) setData(json);
      } catch (e) {
        if (!cancelled) setError(e.message || 'Failed to load pipeline status');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [isActive]);

  const row = (label, iso) => {
    const text = formatTimestamp(iso);
    return (
      <div className="detail-item" key={label}>
        <span className="label">{label}</span>
        <span className="value">{text || 'No data'}</span>
      </div>
    );
  };

  return (
    <div className="component">
      <div className="stocks-header">
        <h2>Pipeline status</h2>
      </div>
      <p className="no-price" style={{ marginTop: 0, marginBottom: '1rem' }}>
        Timestamps reflect the latest price rows and consensus rating / price-target fetches (what the app displays), not every Celery task.
      </p>
      {loading ? (
        <div className="loading">Loading pipeline status...</div>
      ) : error ? (
        <div className="error">{error}</div>
      ) : data ? (
        <div className="stock-details-grid">
          {row('Prices last ingested', data.last_price_data_ingest_at)}
          {row('Consensus data last fetched', data.last_consensus_data_fetched_at)}
          {row('Last ingestion activity', data.last_ingestion_activity_at)}
        </div>
      ) : null}
    </div>
  );
}

export default DebugPipelineFreshness;
